import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import './component.scss';
import Papa from 'papaparse';

application.register('batch-upload', class extends Controller {
  static targets = ['fileInput', 'description'];

  intialize() {
    this.currentFile = null;
  }

  fileLoaded(event) {
    this.currentFile = event.target.files[0];
    Papa.parse(this.currentFile, this.#parseConfig(this));
  }

  submit(e) {
    if (this.currentFile) {
      e.preventDefault();

      const description = this.descriptionTarget.value.trim();
      if (!description) {
        alert('Por favor, preencha a descrição.');
        return;
      }

      this.dispatch('rows-submit', { detail: { fileInput: this.fileInputTarget, fileName: this.currentFile.name } });
    }
  }

  #parseConfig(controller) {
    return {
      header: true,
      skipEmptyLines: true,
      beforeFirstChunk: function (chunk) {
        controller.dispatch('parse-started');
      },
      transform: function (value, header) {
        return value.replace(/\s+/g, ' ').trim();
      },
      step: function ({ data: row, errors }) {
        controller.dispatch('row-load', { detail: { row, errors } })
      },
      complete: function (results) {
        controller.dispatch('parse-complete', { detail: { fileSize: controller.currentFile.size } })
      }
    }
  }
});
